/* eslint-disable unicorn/prefer-module */
/* eslint-disable max-len */
/* eslint-disable prettier/prettier */
/* eslint-disable no-console */
import React, { useCallback, useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Dropdown from "react-bootstrap/Dropdown";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import toast from "react-hot-toast";
import { FaBuilding, FaEdit } from "react-icons/fa";
import { AgenciasDropdown, Loader, matchAgenciaFilter } from "..";
import { ROLES } from "../../constants/roles";
import { useAuthContext } from "../../context/auth";
import { calcularImporteNetoIntermediario, getClientes, getContratos, getConvertedImporte, getIntermediarios, getNegociosCarteleria, getOportunidades, getOportunidadesBTL, getUsers, log, updateContrato, updateOportunidad, updateOportunidadBTL } from "../../utils";
import { client } from "../../utils/supabase";
import { useExchangeRates } from "../../utils/useExchangeRates";
import { Header } from "../Header";
import { ModalAsignarEdificios } from "./ModalAsignarEdificios";
import styles from "./VentasFacturas.module.scss";

export const VentasFacturas = () => {
  const [todasOportunidades, setTodasOportunidades] = useState([]);
  const [oportunidadesFiltradas, setOportunidadesFiltradas] = useState([]);
  const [intermediarios, setIntermediarios] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [filtroNumeroFactura, setFiltroNumeroFactura] = useState("");
  const [filtroCliente, setFiltroCliente] = useState("");
  const [filtroCobrada, setFiltroCobrada] = useState("");
  const [numerosFacturaUnicos, setNumerosFacturaUnicos] = useState([]);
  const [clientesUnicos, setClientesUnicos] = useState([]);
  const [filtroAnos, setFiltroAnos] = useState([new Date().getFullYear().toString()]);
  const [filtroMeses, setFiltroMeses] = useState([]);
  const [filtroTipo, setFiltroTipo] = useState("");
  const [filtroModalidad, setFiltroModalidad] = useState("");
  const [porcentajesVertical, setPorcentajesVertical] = useState({
    publicidad: 0, hardware: 0, gestion: 0, btl: 0,
  });
  const [filtroIntermediario, setFiltroIntermediario] = useState("");
  const [filtroFacturado, setFiltroFacturado] = useState("");
  const [filtroMoneda, setFiltroMoneda] = useState("LOCAL");
  const [showModal, setShowModal] = useState(false);
  const [oportunidadEditada, setOportunidadEditada] = useState(null);
  const [formData, setFormData] = useState({
    facturanumero: "",
    facturafecha: "",
    plazocobro: "",
    facturafechacobro: "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [usuarios, setUsuarios] = useState([]);
  const [filtroEjecutivo, setFiltroEjecutivo] = useState("");
  const [ejecutivosUnicos, setEjecutivosUnicos] = useState([]);
  const [showEdificiosModal, setShowEdificiosModal] = useState(false);
  const [edificiosMesTarget, setEdificiosMesTarget] = useState(null);
  const possibleYears = ["2024", "2025", "2026", "2027"];
  const { pais, rol } = useAuthContext();
  const puedeEditar = [ROLES.GERENCIA, ROLES.ADMINISTRATIVO].includes(rol);
  const { getDolarValue, getUFValue, dolarFallback, loaded: ratesLoaded } = useExchangeRates(pais);

  const localString = useCallback(
    (pais) =>
      ({
        Chile: "es-CL",
        Perú: "es-PE",
      })[pais] || "es-CL",
    []
  );
  const moneda = useCallback(
    (pais) =>
      ({
        Chile: "$",
        Perú: "S/",
      })[pais] || "$",
    []
  );
  const decimales = useCallback(
    (pais) =>
      ({
        Chile: 0,
        Perú: 2,
      })[pais] || 0,
    []
  );
  const getRateForOportunidad = useCallback(
    (oportunidad) => {
      if (!oportunidad.moneda_dolar) return 1;
      const fecha = oportunidad.facturafecha;
      return fecha ? getDolarValue(fecha) : (dolarFallback[pais] || 1);
    },
    [getDolarValue, dolarFallback, pais]
  );

  // Rate del dólar para una fecha (independiente de moneda_dolar)
  const getDolarRateForDate = useCallback(
    (facturafecha) => facturafecha ? getDolarValue(facturafecha) : (dolarFallback[pais] || 1),
    [getDolarValue, dolarFallback, pais]
  );

  // Moneda y decimales de visualización según modo
  const displayMoneda = filtroMoneda === "USD" ? "US$" : moneda(pais);
  const displayDecimales = filtroMoneda === "USD" ? 0 : decimales(pais);

  const mesEnLetras = useCallback((mes) => {
    const mesesEnLetras = ["ENE", "FEB", "MAR", "ABR", "MAY", "JUN", "JUL", "AGO", "SEP", "OCT", "NOV", "DIC"];
    return mesesEnLetras[parseInt(mes, 10) - 1] || "";
  }, []);
  
  const resolverNombreIntermediario = useCallback((intermediarioId, intermediarios) => {
    if (!intermediarioId) return "SIN INTERMEDIARIO";
    const intermediarioAsociado = intermediarios.find(
      (i) => i.id === parseInt(intermediarioId, 10)
    );
    return intermediarioAsociado ? intermediarioAsociado.nombre : "SIN INTERMEDIARIO";
  }, []);

  useEffect(() => {
    const initialize = async () => {
      try {
        const [allOportunidades, allIntermediarios, allClientes, allUsuarios, allContratos, allNegociosCarteleria, edificiosRes] = await Promise.all([
          getOportunidades({ pais }),
          getIntermediarios({ pais }),
          getClientes({ pais }),
          getUsers(),
          getContratos({ pais }),
          getNegociosCarteleria({ pais }),
          client.from("edificios").select("id, edificio").eq("pais", pais),
        ]);
        const edificiosMap = (edificiosRes.data || []).reduce((acc, e) => ({ ...acc, [e.id]: e.edificio }), {});
        const clientesMap = allClientes.reduce((acc, c) => ({ ...acc, [c.id]: c.nombre }), {});
        const allOportunidadesBTLPromises = possibleYears.map(ano => getOportunidadesBTL({ pais, ano }));
        const allOportunidadesBTLArrays = await Promise.all(allOportunidadesBTLPromises);
        const allOportunidadesBTL = allOportunidadesBTLArrays.flat();

        // Deduplicate BTL opportunities by ID
        const seenIds = new Set();
        const uniqueOportunidadesBTL = allOportunidadesBTL.filter((btl) => {
          if (seenIds.has(btl.id)) {
            return false;
          }
          seenIds.add(btl.id);
          return true;
        });

        // Mapear oportunidades regulares con el campo ejecutivo
        const mappedOportunidades = allOportunidades.map((op) => {
          let mes = (new Date().getMonth() + 1).toString().padStart(2, "0");
          let ano = new Date().getFullYear().toString();
          if (op.mes_factura && typeof op.mes_factura === "string") {
            const [month, year] = op.mes_factura.split("-");
            if (month && year) {
              mes = month.padStart(2, "0");
              ano = year;
            }
          }
          return {
            ...op,
            type: "pauta",
            ejecutivo: op.ejecutivo ? parseInt(op.ejecutivo, 10) : null,
            mes,
            ano,
          };
        });

        // Mapear oportunidades BTL con executive_responsible
        const filteredOportunidadesBTL = uniqueOportunidadesBTL.filter(
          (btl) => btl.status === 100 && !btl.eliminada && btl.pais === pais
        );
        const mappedOportunidadesBTL = filteredOportunidadesBTL.map((btl) => {
          let mes = (new Date().getMonth() + 1).toString().padStart(2, "0");
          let ano = new Date().getFullYear().toString();
          if (btl.mes_factura && typeof btl.mes_factura === "string") {
            const [month, year] = btl.mes_factura.split("-");
            if (month && year) {
              mes = month.padStart(2, "0");
              ano = year;
            }
          }
          return {
            id: btl.id,
            client_id: btl.client_id,
            importe: btl.total_investment,
            comision: btl.total_commission,
            facturafecha: btl.facturafecha,
            facturanumero: btl.facturanumero,
            facturafechacobro: btl.facturafechacobro,
            mes,
            ano,
            estatus: "100%",
            eliminada: btl.eliminada,
            cliente: allClientes.find((c) => c.id === btl.client_id)?.nombre || "Desconocido",
            type: "BTL",
            moneda_dolar: btl.moneda_dolar || false,
            ejecutivo: btl.executive_responsible ? parseInt(btl.executive_responsible, 10) : null,
          };
        });

        // Explotar contratos: cada mes del JSONB → una fila facturable
        const mappedContratos = (allContratos || [])
          .filter((c) => !c.eliminada && c.estatus === "100%" && c.pais === pais)
          .flatMap((c) =>
            (c.meses || []).map((mesObj, idx) => {
              const [mesStr, anoStr] = (mesObj.mes || "01-2026").split("-");
              return {
                id: `contrato-${c.id}-${idx}`,
                contrato_id: c.id,
                mes_index: idx,
                client_id: c.client_id,
                importe: mesObj.importe || 0,
                comision: null,
                facturafecha: mesObj.facturafecha,
                facturanumero: mesObj.facturanumero,
                facturafechacobro: mesObj.facturafechacobro,
                plazocobro: mesObj.plazocobro,
                mes: mesStr,
                ano: anoStr,
                estatus: "100%",
                eliminada: false,
                cliente: allClientes.find((cl) => cl.id === c.client_id)?.nombre || c.cliente || "Desconocido",
                type: "contrato",
                moneda_dolar: c.moneda_dolar || false,
                ejecutivo: c.ejecutivo ? parseInt(c.ejecutivo, 10) : null,
                campana: c.campana,
                label_extra: `Mes ${idx + 1}/${(c.meses || []).length}`,
                personas_comprometidas: c.personas_comprometidas,
                edificios_ids: mesObj.edificios_ids || null,
                pantallas_ascensores: mesObj.pantallas_ascensores || "",
                pantallas_espera: mesObj.pantallas_espera || "",
                pantallas_circulacion: mesObj.pantallas_circulacion || "",
                pantallas_cowork: mesObj.pantallas_cowork || "",
                pantallastotales: mesObj.pantallas_totales || 0,
                display_id: c.display_id || null,
              };
            })
          );

        // Generar filas de cartelería (HW-CAPEX, HW-OPEX, Gestión)
        const mappedCarteleria = [];
        const elegibles = allNegociosCarteleria.filter((n) =>
          ["activo", "100%"].includes((n.estado || "").toLowerCase())
        );
        elegibles.forEach((n) => {
          const pantallas = parseInt(n.cantidad_pantallas, 10) || 1;
          const plazo = parseInt(n.plazo_contrato_meses, 10) || 0;
          const nombreCliente = n.tipo_vertical === "TD"
            ? (clientesMap[n.referencia_id] || edificiosMap[n.referencia_id] || n.nombre_proyecto || "—")
            : (edificiosMap[n.referencia_id] || clientesMap[n.referencia_id] || n.nombre_proyecto || "—");
          const ejecutivoId = n.ejecutivo ? parseInt(n.ejecutivo, 10) : null;
          const mesesFact = n.meses_facturacion
            ? (typeof n.meses_facturacion === "string" ? JSON.parse(n.meses_facturacion) : n.meses_facturacion)
            : null;

          // --- HW-CAPEX: una fila por entry en detalle_pagos_hardware ---
          if (n.incluye_hardware && n.modalidad === "CAPEX") {
            const detalle = typeof n.detalle_pagos_hardware === "string"
              ? JSON.parse(n.detalle_pagos_hardware || "[]")
              : (n.detalle_pagos_hardware || []);
            if (detalle.length > 0) {
              detalle.forEach((entry, idx) => {
                const monto = parseFloat(entry.monto) || 0;
                if (monto <= 0) return;
                const fechaRef = entry.facturafecha || entry.fecha_factura || null;
                const [y, m] = fechaRef ? fechaRef.split("-") : [new Date().getFullYear().toString(), "01"];
                let importeFinal = monto;
                let monedaDolar = n.moneda_hardware === "USD";
                if (n.moneda_hardware === "UF") {
                  importeFinal = monto * (getUFValue(fechaRef || new Date().toISOString().split("T")[0]) || 1);
                  monedaDolar = false;
                }
                mappedCarteleria.push({
                  id: `hw-capex-${n.id}-${idx}`, negocio_id: n.id, display_id: n.id,
                  entry_index: idx, client_id: null,
                  importe: importeFinal, comision: null,
                  facturafecha: entry.facturafecha || null, facturanumero: entry.facturanumero || null,
                  facturafechacobro: entry.facturafechacobro || null, plazocobro: entry.plazocobro || null,
                  mes: (m || "01").padStart(2, "0"), ano: y || new Date().getFullYear().toString(),
                  estatus: "100%", eliminada: false, cliente: nombreCliente,
                  type: "HW-CAPEX", moneda_dolar: monedaDolar, ejecutivo: ejecutivoId,
                  label_extra: `Pago ${idx + 1}/${detalle.length}`,
                });
              });
            } else if (parseFloat(n.monto_hardware) > 0) {
              // CAPEX sin detalle: fila única con monto_hardware total
              const fechaRef = n.fecha_cierre || n.fecha_inicio || null;
              const [y, m] = fechaRef ? fechaRef.split("-") : [new Date().getFullYear().toString(), "01"];
              let importeFinal = parseFloat(n.monto_hardware);
              let monedaDolar = n.moneda_hardware === "USD";
              if (n.moneda_hardware === "UF") {
                importeFinal = importeFinal * (getUFValue(fechaRef || new Date().toISOString().split("T")[0]) || 1);
                monedaDolar = false;
              }
              mappedCarteleria.push({
                id: `hw-capex-${n.id}-0`, negocio_id: n.id, display_id: n.id,
                entry_index: 0, client_id: null,
                importe: importeFinal, comision: null,
                facturafecha: null, facturanumero: null, facturafechacobro: null, plazocobro: null,
                mes: (m || "01").padStart(2, "0"), ano: y || new Date().getFullYear().toString(),
                estatus: "100%", eliminada: false, cliente: nombreCliente,
                type: "HW-CAPEX", moneda_dolar: monedaDolar, ejecutivo: ejecutivoId,
                label_extra: "Pago único",
              });
            }
          }

          // --- HW-OPEX: una fila por mes del contrato ---
          if (n.incluye_hardware && n.modalidad === "OPEX" && plazo > 0 && n.fecha_inicio) {
            const cuotaOpex = parseFloat(n.cuota_hardware_opex) || 0;
            if (cuotaOpex > 0) {
              const startDate = new Date(n.fecha_inicio + "T00:00:00");
              for (let i = 0; i < plazo; i++) {
                const mesDate = new Date(startDate.getFullYear(), startDate.getMonth() + i, 1);
                const mesStr = (mesDate.getMonth() + 1).toString().padStart(2, "0");
                const anoStr = mesDate.getFullYear().toString();
                const mesFact = mesesFact?.find((mf) => mf.mes === mesStr && mf.ano === anoStr && mf.tipo === "opex");
                let importeBase = cuotaOpex * pantallas;
                let monedaDolar = n.moneda_hardware === "USD";
                if (n.moneda_hardware === "UF") {
                  const fechaRef = mesFact?.facturafecha || `${anoStr}-${mesStr}-01`;
                  importeBase = importeBase * (getUFValue(fechaRef) || 1);
                  monedaDolar = false;
                }
                mappedCarteleria.push({
                  id: `hw-opex-${n.id}-${i}`, negocio_id: n.id, display_id: n.id, mes_index: i, client_id: null,
                  importe: importeBase, comision: null,
                  facturafecha: mesFact?.facturafecha || null, facturanumero: mesFact?.facturanumero || null,
                  facturafechacobro: mesFact?.facturafechacobro || null, plazocobro: mesFact?.plazocobro || null,
                  mes: mesStr, ano: anoStr, estatus: "100%", eliminada: false, cliente: nombreCliente,
                  type: "HW-OPEX", moneda_dolar: monedaDolar, ejecutivo: ejecutivoId,
                  label_extra: `Mes ${i + 1}/${plazo}`,
                });
              }
            }
          }

          // --- Gestión & Contenidos: una fila por mes (solo EO/TD, no OT) ---
          if (n.tipo_vertical !== "OT" && plazo > 0 && n.fecha_inicio) {
            const feeGestion = parseFloat(n.fee_gestion_unitario) || 0;
            const feeContenidos = n.incluye_contenidos ? (parseFloat(n.fee_contenidos_unitario) || 0) : 0;
            const feeTotal = feeGestion + feeContenidos;
            if (feeTotal > 0) {
              const startDate = new Date(n.fecha_inicio + "T00:00:00");
              for (let i = 0; i < plazo; i++) {
                const mesDate = new Date(startDate.getFullYear(), startDate.getMonth() + i, 1);
                const mesStr = (mesDate.getMonth() + 1).toString().padStart(2, "0");
                const anoStr = mesDate.getFullYear().toString();
                const mesFact = mesesFact?.find((mf) => mf.mes === mesStr && mf.ano === anoStr && mf.tipo === "gestion");
                let importeBase = feeTotal * pantallas;
                let monedaDolar = n.moneda_gestion === "USD";
                if (n.moneda_gestion === "UF") {
                  const fechaRef = mesFact?.facturafecha || `${anoStr}-${mesStr}-01`;
                  importeBase = importeBase * (getUFValue(fechaRef) || 1);
                  monedaDolar = false;
                }
                mappedCarteleria.push({
                  id: `gestion-${n.id}-${i}`, negocio_id: n.id, display_id: n.id, mes_index: i, client_id: null,
                  importe: importeBase, comision: null,
                  facturafecha: mesFact?.facturafecha || null, facturanumero: mesFact?.facturanumero || null,
                  facturafechacobro: mesFact?.facturafechacobro || null, plazocobro: mesFact?.plazocobro || null,
                  mes: mesStr, ano: anoStr, estatus: "100%", eliminada: false, cliente: nombreCliente,
                  type: "Gestión", moneda_dolar: monedaDolar, ejecutivo: ejecutivoId,
                  label_extra: `${i + 1}/${plazo}`,
                  valor_cuota: feeTotal * pantallas, moneda_cuota: n.moneda_gestion,
                });
              }
            }
          }
        });

        const combinedOportunidades = [...mappedOportunidades, ...mappedOportunidadesBTL, ...mappedContratos, ...mappedCarteleria];
        setTodasOportunidades(combinedOportunidades);
        setIntermediarios(allIntermediarios);
        setClientes(allClientes);
        setUsuarios(allUsuarios);

        // Mapear ejecutivos únicos basados en los IDs con ventas al 100%
        const uniqueEjecutivoIds = [...new Set(combinedOportunidades.map((op) => op.ejecutivo).filter((id) => id !== null))];
        const ejecutivosUnicos = uniqueEjecutivoIds
          .map((ejecutivoId) => {
            const usuario = allUsuarios.find((u) => parseInt(u.id, 10) === ejecutivoId);
            return usuario ? { id: ejecutivoId, nombre: usuario.nombre } : null;
          })
          .filter((u) => u !== null)
          .sort((a, b) => a.nombre.localeCompare(b.nombre));
        setEjecutivosUnicos(ejecutivosUnicos);
      } catch (error) {
        console.error("Error al inicializar datos:", error);
        log.error("initialize", error);
        toast.error("Error al cargar los datos iniciales");
      }
    };
    initialize();
  }, [pais]);

  useEffect(() => {
    const filtrarOportunidades = () => {
      // Filtrado base (sin filtro de tipo) para calcular % por vertical
      const filtradasBase = todasOportunidades.filter((oportunidad) => {
        const fechaFactura = oportunidad.facturafecha ? new Date(oportunidad.facturafecha) : null;
        const mesFactura = fechaFactura ? (fechaFactura.getMonth() + 1).toString().padStart(2, "0") : null;
        const mesOportunidad = oportunidad.mes ? oportunidad.mes.toString().padStart(2, "0") : null;
        const anoFactura = fechaFactura ? fechaFactura.getFullYear() : null;
        const anoOportunidad = oportunidad.ano ? parseInt(oportunidad.ano, 10) : null;
        const mesParaFiltrar = fechaFactura ? mesFactura : mesOportunidad;
        const anoParaFiltrar = fechaFactura ? anoFactura : anoOportunidad;
        const mesFiltrado = filtroMeses.length > 0
          ? (mesParaFiltrar ? filtroMeses.includes(mesParaFiltrar) : false) : true;
        const clienteAsociado = clientes.find((c) => c.id === oportunidad.client_id);
        const intermediarioId = clienteAsociado ? clienteAsociado.agencia : null;
        const intermediarioFiltrado = matchAgenciaFilter(filtroIntermediario, intermediarioId, pais);
        const facturadoFiltrado = filtroFacturado
          ? filtroFacturado === "Facturado"
            ? oportunidad.facturanumero && oportunidad.facturanumero.trim() !== ""
            : !oportunidad.facturanumero || oportunidad.facturanumero.trim() === ""
          : true;
        const perteneceAlAno = filtroAnos.length > 0 ? filtroAnos.includes(anoParaFiltrar?.toString()) : true;
        const ejecutivoFiltrado = filtroEjecutivo
          ? oportunidad.ejecutivo === parseInt(filtroEjecutivo, 10)
          : true;
        return (
          mesFiltrado &&
          intermediarioFiltrado &&
          (filtroNumeroFactura ? oportunidad.facturanumero === filtroNumeroFactura : true) &&
          (filtroCliente ? oportunidad.cliente === filtroCliente : true) &&
          (filtroCobrada
            ? filtroCobrada === "Sí"
              ? oportunidad.facturafechacobro
              : !oportunidad.facturafechacobro
            : true) &&
          facturadoFiltrado &&
          perteneceAlAno &&
          ejecutivoFiltrado &&
          oportunidad.estatus === "100%" &&
          !oportunidad.eliminada
        );
      });

      // Calcular % por vertical sobre filtradasBase
      const totales = { publicidad: 0, hardware: 0, gestion: 0, btl: 0 };
      filtradasBase.forEach((o) => {
        const imp = parseFloat(o.importe) || 0;
        if (["pauta", "contrato"].includes(o.type)) totales.publicidad += imp;
        else if (["HW-CAPEX", "HW-OPEX"].includes(o.type)) totales.hardware += imp;
        else if (o.type === "Gestión") totales.gestion += imp;
        else if (o.type === "BTL") totales.btl += imp;
      });
      const totalGeneral = totales.publicidad + totales.hardware + totales.gestion + totales.btl;
      setPorcentajesVertical({
        publicidad: totalGeneral > 0 ? Math.round((totales.publicidad / totalGeneral) * 100) : 0,
        hardware: totalGeneral > 0 ? Math.round((totales.hardware / totalGeneral) * 100) : 0,
        gestion: totalGeneral > 0 ? Math.round((totales.gestion / totalGeneral) * 100) : 0,
        btl: totalGeneral > 0 ? Math.round((totales.btl / totalGeneral) * 100) : 0,
      });

      // Aplicar filtro de tipo
      const filtradas = filtradasBase
        .filter((oportunidad) => {
          if (filtroTipo === "publicidad") return ["pauta", "contrato"].includes(oportunidad.type);
          if (filtroTipo === "hardware") {
            if (filtroModalidad === "CAPEX") return oportunidad.type === "HW-CAPEX";
            if (filtroModalidad === "OPEX") return oportunidad.type === "HW-OPEX";
            return ["HW-CAPEX", "HW-OPEX"].includes(oportunidad.type);
          }
          if (filtroTipo === "Gestión") return oportunidad.type === "Gestión";
          if (filtroTipo === "BTL") return oportunidad.type === "BTL";
          return true;
        })
        .map((oportunidad) => {
          let comision = oportunidad.comision;
          const esCarteleria = ["HW-CAPEX", "HW-OPEX", "Gestión"].includes(oportunidad.type);
          let intermediarioNombre = (oportunidad.type === "BTL" || esCarteleria) ? "DIRECTO" : null;
          const ejecutivoAsociado = usuarios.find((u) => parseInt(u.id, 10) === oportunidad.ejecutivo);
          const ejecutivoNombre = ejecutivoAsociado
            ? ejecutivoAsociado.nombre
            : "??";
          if (oportunidad.type !== "BTL" && !esCarteleria) {
            const clienteAsociado = clientes.find((c) => c.id === oportunidad.client_id);
            const intermediarioId = clienteAsociado ? clienteAsociado.agencia : null;
            intermediarioNombre = resolverNombreIntermediario(intermediarioId, intermediarios);
            const anoOportunidad = oportunidad.facturafecha
              ? new Date(oportunidad.facturafecha).getFullYear()
              : oportunidad.ano
                ? parseInt(oportunidad.ano, 10)
                : new Date().getFullYear();
            const intermediarioAsociado = intermediarios.find(
              (i) => i.id === parseInt(intermediarioId, 10)
            );
            if (intermediarioAsociado) {
              if (
                intermediarioAsociado.comision_2 !== null &&
                intermediarioAsociado.comision_2_fechainicio &&
                intermediarioAsociado.comision_2_fechafin
              ) {
                const fechaInicio = new Date(intermediarioAsociado.comision_2_fechainicio);
                const fechaFin = new Date(intermediarioAsociado.comision_2_fechafin);
                const anoInicio = fechaInicio.getFullYear();
                const anoFin = fechaFin.getFullYear();
                comision =
                  anoOportunidad >= anoInicio && anoOportunidad <= anoFin
                    ? intermediarioAsociado.comision_2 || 0
                    : intermediarioAsociado.comision || 0;
              } else {
                comision = intermediarioAsociado.comision || 0;
              }
            }
          }
          return {
            ...oportunidad,
            intermediario: intermediarioNombre,
            comision,
            moneda_dolar: oportunidad.moneda_dolar || false,
            ejecutivoNombre,
            ano: oportunidad.ano ? oportunidad.ano.toString() : new Date().getFullYear().toString(),
          };
        });
      const filtradasOrdenadas = filtradas.sort((a, b) => {
        // 1) Facturado primero, sin facturar después
        const hasFactA = a.facturanumero ? 0 : 1;
        const hasFactB = b.facturanumero ? 0 : 1;
        if (hasFactA !== hasFactB) return hasFactA - hasFactB;
        // 2) Fecha factura cronológica (más antigua primero)
        const fechaA = a.facturafecha ? new Date(a.facturafecha).getTime() : 0;
        const fechaB = b.facturafecha ? new Date(b.facturafecha).getTime() : 0;
        if (fechaA !== fechaB) return fechaA - fechaB;
        // 3) Periodo cronológico (año + mes) para cuotas sin fecha
        const anoA = parseInt(a.ano, 10) || new Date().getFullYear();
        const anoB = parseInt(b.ano, 10) || new Date().getFullYear();
        if (anoA !== anoB) return anoA - anoB;
        const mesA = parseInt(a.mes, 10) || 1;
        const mesB = parseInt(b.mes, 10) || 1;
        if (mesA !== mesB) return mesA - mesB;
        // 4) Importe descendente como desempate
        const impA = parseFloat(a.importe) || 0;
        const impB = parseFloat(b.importe) || 0;
        return impB - impA;
      });
      setOportunidadesFiltradas(filtradasOrdenadas);
      const numerosFactura = [...new Set(filtradasOrdenadas.map((o) => o.facturanumero))]
        .filter(Boolean)
        .sort((a, b) => a.localeCompare(b, undefined, { numeric: true }));
      setNumerosFacturaUnicos(numerosFactura);
      const clientesUnicosList = [...new Set(filtradasOrdenadas.map((o) => o.cliente))].filter(Boolean).sort();
      setClientesUnicos(clientesUnicosList);
    };
    if (todasOportunidades.length > 0 && clientes.length > 0 && intermediarios.length > 0 && usuarios.length > 0) {
      filtrarOportunidades();
    }
  }, [
    filtroMeses,
    filtroNumeroFactura,
    filtroCliente,
    filtroCobrada,
    filtroFacturado,
    filtroAnos,
    filtroIntermediario,
    filtroTipo,
    filtroModalidad,
    filtroEjecutivo,
    todasOportunidades,
    intermediarios,
    clientes,
    usuarios,
    resolverNombreIntermediario,
    pais,
  ]);

  const handleOpenModal = (oportunidad) => {
    setOportunidadEditada(oportunidad);
    setFormData({
      facturanumero: oportunidad.facturanumero || "",
      facturafecha: oportunidad.facturafecha
        ? new Date(oportunidad.facturafecha).toISOString().split("T")[0]
        : "",
      plazocobro: oportunidad.plazocobro
        ? new Date(oportunidad.plazocobro).toISOString().split("T")[0]
        : "",
      facturafechacobro: oportunidad.facturafechacobro
        ? new Date(oportunidad.facturafechacobro).toISOString().split("T")[0]
        : "",
    });
    setShowModal(true);
    setError(null);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setOportunidadEditada(null);
    setFormData({ facturanumero: "", facturafecha: "", facturafechacobro: "" });
    setError(null);
    setLoading(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSaveChanges = async () => {
    if (!oportunidadEditada) return;

    // Validaciones
    if (!formData.facturanumero.trim()) {
      setError("El número de factura es obligatorio");
      return;
    }
    if (!formData.facturafecha) {
      setError("La fecha de factura es obligatoria");
      return;
    }

    // Validar que plazocobro >= facturafecha
    if (formData.plazocobro && formData.plazocobro < formData.facturafecha) {
      setError("La fecha proyectada no puede ser anterior a la fecha de factura");
      return;
    }

    // Validar que facturafechacobro >= facturafecha
    if (formData.facturafechacobro && formData.facturafechacobro < formData.facturafecha) {
      setError("La fecha real de cobro no puede ser anterior a la fecha de factura");
      return;
    }

    // Verificar unicidad del número de factura
    // Solo valida si el número de factura cambió
    if (formData.facturanumero !== oportunidadEditada.facturanumero) {
      const duplicado = todasOportunidades.some(
        (op) =>
          op.facturanumero === formData.facturanumero &&
      op.id !== oportunidadEditada.id
      );
      if (duplicado) {
        setError("El número de factura ya está usado en otra oportunidad");
        return;
      }
    }

    try {
      setLoading(true);

      const updatedOportunidad = {
        facturafecha: formData.facturafecha, // "2025-12-10"
        facturafechacobro: formData.facturafechacobro || null,
        plazocobro: formData.plazocobro || null,
        facturanumero: formData.facturanumero,
        updated_at: new Date().toISOString(),
      };

      if (oportunidadEditada.type === "contrato") {
        // Contratos: actualizar el mes específico dentro del JSONB meses
        const contratosRaw = await getContratos({ pais });
        const contrato = contratosRaw.find((c) => c.id === oportunidadEditada.contrato_id);
        if (!contrato) throw new Error("Contrato no encontrado");
        const updatedMeses = [...(contrato.meses || [])];
        updatedMeses[oportunidadEditada.mes_index] = {
          ...updatedMeses[oportunidadEditada.mes_index],
          facturafecha: updatedOportunidad.facturafecha,
          facturanumero: updatedOportunidad.facturanumero,
          plazocobro: updatedOportunidad.plazocobro,
          facturafechacobro: updatedOportunidad.facturafechacobro,
        };
        await updateContrato({ id: contrato.id, contrato: { meses: updatedMeses } });
      } else if (oportunidadEditada.type === "HW-CAPEX") {
        // HW-CAPEX: actualizar entry en detalle_pagos_hardware del negocio
        const { data: negocio } = await client
          .from("negocios_carteleria").select("detalle_pagos_hardware").eq("id", oportunidadEditada.negocio_id).single();
        const detalle = typeof negocio.detalle_pagos_hardware === "string"
          ? JSON.parse(negocio.detalle_pagos_hardware || "[]") : (negocio.detalle_pagos_hardware || []);
        detalle[oportunidadEditada.entry_index] = {
          ...detalle[oportunidadEditada.entry_index],
          facturafecha: updatedOportunidad.facturafecha,
          facturanumero: updatedOportunidad.facturanumero,
          plazocobro: updatedOportunidad.plazocobro,
          facturafechacobro: updatedOportunidad.facturafechacobro,
        };
        await client.from("negocios_carteleria").update({ detalle_pagos_hardware: detalle }).eq("id", oportunidadEditada.negocio_id);
      } else if (oportunidadEditada.type === "HW-OPEX" || oportunidadEditada.type === "Gestión") {
        // OPEX/Gestión: actualizar o crear entry en meses_facturacion JSONB
        const tipoFact = oportunidadEditada.type === "HW-OPEX" ? "opex" : "gestion";
        const { data: negocio } = await client
          .from("negocios_carteleria").select("meses_facturacion").eq("id", oportunidadEditada.negocio_id).single();
        const mesesFact = negocio.meses_facturacion
          ? (typeof negocio.meses_facturacion === "string" ? JSON.parse(negocio.meses_facturacion) : negocio.meses_facturacion)
          : [];
        const existingIdx = mesesFact.findIndex(
          (mf) => mf.mes === oportunidadEditada.mes && mf.ano === oportunidadEditada.ano && mf.tipo === tipoFact
        );
        const entry = {
          mes: oportunidadEditada.mes, ano: oportunidadEditada.ano, tipo: tipoFact,
          facturafecha: updatedOportunidad.facturafecha,
          facturanumero: updatedOportunidad.facturanumero,
          plazocobro: updatedOportunidad.plazocobro,
          facturafechacobro: updatedOportunidad.facturafechacobro,
        };
        if (existingIdx >= 0) {
          mesesFact[existingIdx] = { ...mesesFact[existingIdx], ...entry };
        } else {
          mesesFact.push(entry);
        }
        await client.from("negocios_carteleria").update({ meses_facturacion: mesesFact }).eq("id", oportunidadEditada.negocio_id);
      } else if (oportunidadEditada.type === "BTL") {
        await updateOportunidadBTL({ id: oportunidadEditada.id, oportunidad: updatedOportunidad });
      } else {
        await updateOportunidad({ id: oportunidadEditada.id, oportunidad: updatedOportunidad });
      }

      // Recalcular mes/ano derivados si la fecha de factura cambió
      let derivedFields = {};
      if (updatedOportunidad.facturafecha) {
        const [y, mStr] = updatedOportunidad.facturafecha.split("-");
        derivedFields = { mes: mStr, ano: y };
      }
      setTodasOportunidades((prev) =>
        prev.map((op) =>
          op.id === oportunidadEditada.id ? { ...op, ...updatedOportunidad, ...derivedFields } : op
        )
      );

      toast.success("Factura actualizada correctamente");
      handleCloseModal();
    } catch (error) {
      if (error.code === "23505") {
        setError("El número de factura ya existe");
      } else {
        setError("Hubo un error al actualizar la oportunidad, prueba de nuevo.");
      }
      log.error("handleSaveChanges", error);
    } finally {
      setLoading(false);
    }
  };

  // --- Asignación de edificios para contratos AR ---
  const handleOpenEdificios = (oportunidad) => {
    setEdificiosMesTarget(oportunidad);
    setShowEdificiosModal(true);
  };

  const handleSaveEdificios = async (idsString, edificiosTotales, pantallasTotales, personasAsignadas, perTypeData) => {
    if (!edificiosMesTarget) return;
    try {
      const contratosRaw = await getContratos({ pais });
      const contrato = contratosRaw.find((c) => c.id === edificiosMesTarget.contrato_id);
      if (!contrato) throw new Error("Contrato no encontrado");
      const updatedMeses = [...(contrato.meses || [])];
      updatedMeses[edificiosMesTarget.mes_index] = {
        ...updatedMeses[edificiosMesTarget.mes_index],
        edificios_ids: idsString || null,
        edificios_totales: edificiosTotales,
        pantallas_totales: pantallasTotales,
        personas_asignadas: personasAsignadas,
        pantallas_ascensores: perTypeData?.pantallas_ascensores || "",
        pantallas_espera: perTypeData?.pantallas_espera || "",
        pantallas_circulacion: perTypeData?.pantallas_circulacion || "",
        pantallas_cowork: perTypeData?.pantallas_cowork || "",
      };
      await updateContrato({ id: contrato.id, contrato: { meses: updatedMeses } });
      toast.success("Edificios asignados correctamente");
      // Actualizar state local sin recargar página
      const updatedMesData = updatedMeses[edificiosMesTarget.mes_index];
      setTodasOportunidades((prev) =>
        prev.map((op) =>
          op.id === edificiosMesTarget.id
            ? {
                ...op,
                edificios_ids: updatedMesData.edificios_ids,
                pantallastotales: updatedMesData.pantallas_totales || 0,
                pantallas_ascensores: updatedMesData.pantallas_ascensores || "",
                pantallas_espera: updatedMesData.pantallas_espera || "",
                pantallas_circulacion: updatedMesData.pantallas_circulacion || "",
                pantallas_cowork: updatedMesData.pantallas_cowork || "",
              }
            : op
        )
      );
      setShowEdificiosModal(false);
      setEdificiosMesTarget(null);
    } catch (err) {
      console.error("Error asignando edificios:", err);
      toast.error("Error al asignar edificios");
    }
  };

  const calcularTotales = () => {
    let totalVenta = 0;
    let totalComisionIntermediario = 0;
    let totalNeto = 0;
    let totalCobrado = 0;
    let totalFacturado = 0;

    const hoy = new Date();
    hoy.setHours(0, 0, 0, 0);

    oportunidadesFiltradas.forEach((oportunidad) => {
      const importeLocal = getConvertedImporte(oportunidad, getRateForOportunidad(oportunidad));
      const dolarRate = getDolarRateForDate(oportunidad.facturafecha);
      const importeDisplay = filtroMoneda === "USD" ? importeLocal / dolarRate : importeLocal;
      totalVenta += importeDisplay;

      const netoLocal = calcularImporteNetoIntermediario(
        { ...oportunidad, importe: importeLocal },
        Object.values(clientes),
        Object.values(intermediarios),
        pais
      );
      const comisionLocal = importeLocal - netoLocal;
      const comisionDisplay = filtroMoneda === "USD" ? comisionLocal / dolarRate : comisionLocal;
      totalComisionIntermediario += comisionDisplay;

      // Sumar a facturado si tiene número de factura
      if (oportunidad.facturanumero) {
        totalFacturado += importeDisplay;
      }

      if (oportunidad.facturafechacobro) {
        const fechaCobro = new Date(oportunidad.facturafechacobro);
        fechaCobro.setHours(0, 0, 0, 0);
        if (fechaCobro <= hoy) {
          totalCobrado += importeDisplay;
        }
      }
    });

    totalNeto = totalVenta - totalComisionIntermediario;

    // Calcular porcentaje facturado
    const porcentajeFacturado = totalVenta > 0 ? (totalFacturado / totalVenta) * 100 : 0;

    return {
      totalVenta,
      totalComisionIntermediario,
      totalNeto,
      totalCobrado,
      totalFacturado,
      porcentajeFacturado,
    };
  };

  const totales = calcularTotales();
  const fecha = { day: "2-digit", month: "2-digit", year: "numeric" };

  if (!ratesLoaded || todasOportunidades.length === 0 || intermediarios.length === 0 || clientes.length === 0 || usuarios.length === 0) return <Loader />;

  const renderMesOptions = () =>
    ["ENE", "FEB", "MAR", "ABR", "MAY", "JUN", "JUL", "AGO", "SEP", "OCT", "NOV", "DIC"].map((mes, index) => (
      <div key={index} className="form-check-facturas" style={{ marginBottom: "5px" }}>
        <input
          className={styles.checkboxInput} type="checkbox"
          id={`mes${index}`}
          value={index < 9 ? `0${index + 1}` : `${index + 1}`}
          checked={filtroMeses.includes(index < 9 ? `0${index + 1}` : `${index + 1}`)}
          onChange={(e) => handleMesChange(e.target.value)}
        />
        <label
          className={styles.checkboxLabel}
          htmlFor={`mes${index}`}
        >
          {mes}
        </label>
      </div>
    ));

  const handleMesChange = (mes) => {
    setFiltroMeses((prev) =>
      prev.includes(mes) ? prev.filter((item) => item !== mes) : [...prev, mes]
    );
  };

  const renderAnoOptions = () =>
    possibleYears.map((year, index) => (
      <div key={index} className="form-check-facturas" style={{ marginBottom: "5px" }}>
        <input
          className={styles.checkboxInput} type="checkbox"
          id={`ano${index}`}
          value={year}
          checked={filtroAnos.includes(year)}
          onChange={(e) => handleAnoChange(e.target.value)}
        />
        <label
          className={styles.checkboxLabel}
          htmlFor={`ano${index}`}
        >
          {year}
        </label>
      </div>
    ));

  const handleAnoChange = (ano) => {
    setFiltroAnos((prev) =>
      prev.includes(ano) ? prev.filter((item) => item !== ano) : [...prev, ano]
    );
  };

  // FUNCIÓN SEGURA
  const fechaLocal = (fechaISO) => {
    if (!fechaISO) return null;
    const [y, m, d] = fechaISO.split("T")[0].split("-");
    if (!y || !m || !d) return null;
    return new Date(y, m - 1, d);
  };

  const hoy = fechaLocal(new Date().toISOString().split("T")[0]);
  const mesActual = (new Date().getMonth() + 1).toString().padStart(2, "0");
  const anoActual = new Date().getFullYear().toString();

  const esCuotaEditable = (mes, ano) => {
    if (!mes || !ano) return false;
    const anoNum = parseInt(ano, 10);
    const mesNum = parseInt(mes, 10);
    const anoActNum = parseInt(anoActual, 10);
    const mesActNum = parseInt(mesActual, 10);
    return anoNum < anoActNum || (anoNum === anoActNum && mesNum <= mesActNum);
  };

  const getEstadoCobro = (facturafecha, facturafechacobro, plazocobro) => {
    const fechaCobro = facturafechacobro ? fechaLocal(facturafechacobro) : null;
    const fechaFactura = facturafecha ? fechaLocal(facturafecha) : null;

    // 1. COBRADO Y EN FECHA
    if (fechaCobro && fechaCobro <= hoy) {
      return { bg: "#198754", text: fechaCobro.toLocaleDateString("es-ES", fecha) };
    }

    // 2. COBRADO EN FUTURO → ROJO
    if (fechaCobro && fechaCobro > hoy) {
      return { bg: "#dc3545", text: fechaCobro.toLocaleDateString("es-ES", fecha) };
    }

    // 3. FACTURADO, NO COBRADO → ROJO + fecha factura
    if (fechaFactura) {
      return { bg: "#dc3545", text: fechaFactura.toLocaleDateString("es-ES", fecha) };
    }

    // 4. SIN FACTURAR
    return { bg: "#4c5257", text: "Sin facturar" };
  };

  const renderFilters = () => (
    <div className={styles.filtersContainer}>
      <div className={styles.filterRow}>
        <select
          className={`form-select ${filtroNumeroFactura ? styles.activeFilter : ""}`}
          value={filtroNumeroFactura}
          onChange={(e) => setFiltroNumeroFactura(e.target.value)}
        >
          <option value="">Nº Factura</option>
          {numerosFacturaUnicos.map((numero) => (
            <option key={numero} value={numero}>{numero}</option>
          ))}
        </select>
        <select
          className={`form-select ${filtroEjecutivo ? styles.activeFilter : ""}`}
          value={filtroEjecutivo}
          onChange={(e) => setFiltroEjecutivo(e.target.value)}
        >
          <option value="">Ejecutivo</option>
          {ejecutivosUnicos.map((ejecutivo) => (
            <option key={ejecutivo.id} value={ejecutivo.id}>
              {ejecutivo.nombre}
            </option>
          ))}
        </select>
        <select
          className={`form-select ${filtroFacturado ? styles.activeFilter : ""}`}
          value={filtroFacturado}
          onChange={(e) => setFiltroFacturado(e.target.value)}
        >
          <option value="">Todo</option>
          <option value="Facturado">Facturado</option>
          <option value="Sin facturar">Sin facturar</option>
        </select>
        <select
          className={`form-select ${filtroCliente ? styles.activeFilter : ""}`}
          value={filtroCliente}
          onChange={(e) => setFiltroCliente(e.target.value)}
        >
          <option value="">Cliente</option>
          {clientesUnicos.map((cliente) => (
            <option key={cliente} value={cliente}>{cliente}</option>
          ))}
        </select>
        <Dropdown>
          <Dropdown.Toggle
            variant="white"
            id="dropdown-mes"
            className={`${styles.dropdownToggle} ${filtroMeses.length > 0 ? styles.activeFilter : ""}`}
          >
            {filtroMeses.length > 0 ? filtroMeses.map((mes) => mesEnLetras(mes)).join(", ") : "Mes"}
          </Dropdown.Toggle>
          <Dropdown.Menu style={{ maxHeight: "370px", overflowY: "auto" }}>
            {renderMesOptions()}
          </Dropdown.Menu>
        </Dropdown>
      </div>
      <div className={styles.filterRow}>
        <AgenciasDropdown
          value={filtroIntermediario}
          onChange={(e) => setFiltroIntermediario(e.target.value)}
          intermediarios={intermediarios}
          placeholder="Intermediario"
          className={`form-select ${filtroIntermediario ? styles.activeFilter : ""}`}
        />
        <select
          className={`form-select ${styles.activeFilter}`}
          value={filtroMoneda}
          onChange={(e) => setFiltroMoneda(e.target.value)}
        >
          <option value="LOCAL">{pais === "Chile" ? "CLP" : "PEN"}</option>
          <option value="USD">US$</option>
        </select>
        <Dropdown>
          <Dropdown.Toggle
            variant="white"
            id="dropdown-ano"
            className={`${styles.dropdownToggle} ${filtroAnos.length > 0 ? styles.activeFilter : ""}`}
          >
            {filtroAnos.length > 0 ? filtroAnos.join(", ") : "Año"}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {renderAnoOptions()}
          </Dropdown.Menu>
        </Dropdown>
        <select
          className={`form-select ${filtroCobrada ? styles.activeFilter : ""}`}
          value={filtroCobrada}
          onChange={(e) => setFiltroCobrada(e.target.value)}
        >
          <option value="">Cobrada</option>
          <option value="Sí">Sí</option>
          <option value="No">No</option>
        </select>
        <select
          className={`form-select ${filtroModalidad ? styles.activeFilter : ""}`}
          value={filtroModalidad}
          onChange={(e) => setFiltroModalidad(e.target.value)}
          disabled={filtroTipo !== "hardware"}
          style={{ opacity: filtroTipo !== "hardware" ? 0.4 : 1 }}
        >
          <option value="">Modalidad</option>
          <option value="CAPEX">CAPEX</option>
          <option value="OPEX">OPEX</option>
        </select>
      </div>
    </div>
  );

  // ─── Render functions por tipo de vista ──────────────────────
  const renderTablePublicidad = () => (
    <div className={styles.tableResponsive}>
      <table className={`table table-hover table-striped ${styles.table}`}>
        <thead className="text-center align-middle">
          <tr>
            <th className={styles.colStatus}>ID</th>
            <th className={styles.colTipo}>TIPO</th>
            <th className={styles.colEjecutivo}>EJECUTIVO</th>
            <th className={styles.colNumeroFactura}>Nº FACTURA</th>
            <th className={styles.colFechaFactura}>FECHA FACTURA</th>
            <th className={styles.colCliente}>CLIENTE</th>
            <th className={styles.colIntermediario}>INTERMEDIARIO</th>
            <th className={styles.colVenta}>VENTA</th>
            <th className={styles.colComision}>COMISIÓN %</th>
            <th className={styles.colComision}>COMISIÓN {displayMoneda}</th>
            <th className={styles.colNeto}>NETO</th>
            <th className={styles.colCobrada}>COBRADA</th>
            <th className={styles.colEditar}>EDIT</th>
          </tr>
        </thead>
        <tbody>
          {oportunidadesFiltradas.length === 0 ? (
            <tr>
              <td colSpan="13" className="text-center">
                No hay facturas ni ventas según los filtros seleccionados
              </td>
            </tr>
          ) : (
            oportunidadesFiltradas.map((oportunidad) => {
              const {
                id,
                display_id,
                type,
                ejecutivoNombre,
                facturafecha,
                facturanumero,
                cliente,
                intermediario,
                comision,
                facturafechacobro,
                plazocobro,
                mes,
                ano,
                client_id,
                personas_comprometidas,
                edificios_ids,
              } = oportunidad;

              const estado = getEstadoCobro(facturafecha, facturafechacobro, plazocobro);
              const importeLocal = getConvertedImporte(oportunidad, getRateForOportunidad(oportunidad));
              const dolarRate = getDolarRateForDate(facturafecha);
              const importeDisplay = filtroMoneda === "USD" ? importeLocal / dolarRate : importeLocal;
              const netoLocal = calcularImporteNetoIntermediario(
                { importe: importeLocal, facturafecha, client_id },
                Object.values(clientes),
                Object.values(intermediarios),
                pais
              );
              const comisionLocal = importeLocal - netoLocal;
              const comisionDisplay = filtroMoneda === "USD" ? comisionLocal / dolarRate : comisionLocal;
              const netoDisplay = importeDisplay - comisionDisplay;

              return (
                <tr key={id}>
                  <td className={`${styles.colStatus} bg-success text-white`}>
                    {display_id || id}
                  </td>
                  <td className={styles.colTipo}>
                    {type === "BTL"
                      ? "BTL"
                      : type === "HW-CAPEX"
                        ? "CAPEX"
                        : type === "HW-OPEX"
                          ? "OPEX"
                          : type === "Gestión"
                            ? "Gestión"
                            : "Pauta"}
                  </td>
                  <td className={styles.colEjecutivo}>{ejecutivoNombre}</td>
                  <td className={styles.colNumeroFactura}>
                    {facturanumero || (
                      <span style={{ color: facturafecha ? "#dc3545" : undefined, fontWeight: facturafecha ? 600 : undefined }}>
                        -
                      </span>
                    )}
                  </td>
                  <td className={styles.colFechaFactura}>
                    {facturafecha ? (
                      <span style={{ color: "black" }}>
                        {fechaLocal(facturafecha).toLocaleDateString("es-ES", fecha)}
                      </span>
                    ) : (
                      <span style={{ color: "red" }}>
                        {mes && ano ? `${mesEnLetras(mes)}/${ano.slice(-2)}` : "-"}
                      </span>
                    )}
                  </td>
                  <td className={styles.colCliente}>{(cliente || "").toUpperCase()}</td>
                  <td className={styles.colIntermediario}>{intermediario}</td>
                  <td className={`${styles.colVenta} text-end`}>
                    {`${displayMoneda} ${importeDisplay.toLocaleString(
                      localString(pais),
                      {
                        maximumFractionDigits: displayDecimales,
                        minimumFractionDigits: displayDecimales,
                      }
                    )}`}
                  </td>
                  <td className={`${styles.colComision} text-center`}>
                    {(comision || 0).toFixed(1)}%
                  </td>
                  <td className={`${styles.colComision} text-end`}>
                    {`${displayMoneda} ${comisionDisplay.toLocaleString(localString(pais), {
                      maximumFractionDigits: displayDecimales,
                      minimumFractionDigits: displayDecimales,
                    })}`}
                  </td>
                  <td className={`${styles.colNeto} text-end`}>
                    {`${displayMoneda} ${netoDisplay.toLocaleString(localString(pais), {
                      maximumFractionDigits: displayDecimales,
                      minimumFractionDigits: displayDecimales,
                    })}`}
                  </td>
                  <td
                    className={styles.colCobrada}
                    style={{
                      backgroundColor: estado.bg,
                      color: "white",
                      fontWeight: "500",
                    }}
                  >
                    {estado.text}
                  </td>
                  <td className={`${styles.colEditar} text-center align-middle`}>
                    <FaEdit
                      onClick={puedeEditar ? () => handleOpenModal(oportunidad) : undefined}
                      style={{
                        cursor: puedeEditar ? "pointer" : "not-allowed",
                        fontSize: "1.2em",
                        opacity: puedeEditar ? 1 : 0.4,
                      }}
                    />
                    {(() => {
                      const canAssign =
                        puedeEditar &&
                        type === "contrato" &&
                        personas_comprometidas &&
                        !edificios_ids;
                      return (
                        <FaBuilding
                          onClick={canAssign ? () => handleOpenEdificios(oportunidad) : undefined}
                          title={
                            edificios_ids
                              ? "Inventario asignado"
                              : "Asignar edificios"
                          }
                          style={{
                            cursor: canAssign ? "pointer" : "default",
                            fontSize: "1em",
                            marginLeft: "6px",
                            color: "#212529",
                            opacity: canAssign ? 1 : 0.3,
                          }}
                        />
                      );
                    })()}
                  </td>
                </tr>
              );
            })
          )}
        </tbody>
      </table>
    </div>
  );

  const renderTableSummary = () => (
    <div className={styles.tableResponsive}>
      <table className={`table table-hover table-striped ${styles.table}`}>
        <thead className="text-center align-middle">
          <tr>
            <th className={styles.colSumTipo}>TIPO</th>
            <th className={styles.colSumEjecutivo}>EJECUTIVO</th>
            <th className={styles.colSumCliente}>CLIENTE</th>
            <th className={styles.colSumNumeroFactura}>Nº FACTURA</th>
            <th className={styles.colSumFechaFactura}>FECHA FACTURA</th>
            <th className={styles.colSumImporte}>IMPORTE</th>
            <th className={styles.colSumCobrada}>COBRADA</th>
          </tr>
        </thead>
        <tbody>
          {oportunidadesFiltradas.length === 0 ? (
            <tr>
              <td colSpan="7" className="text-center">
                No hay facturas ni ventas según los filtros seleccionados
              </td>
            </tr>
          ) : (
            oportunidadesFiltradas.map((oportunidad) => {
              const {
                id,
                type,
                ejecutivoNombre,
                facturafecha,
                facturanumero,
                cliente,
                facturafechacobro,
                plazocobro,
                mes,
                ano,
              } = oportunidad;

              const estado = getEstadoCobro(facturafecha, facturafechacobro, plazocobro);
              const importeLocal = getConvertedImporte(oportunidad, getRateForOportunidad(oportunidad));
              const dolarRate = getDolarRateForDate(facturafecha);
              const importeDisplay = filtroMoneda === "USD" ? importeLocal / dolarRate : importeLocal;

              return (
                <tr key={id}>
                  <td className={styles.colSumTipo}>
                    {["pauta", "contrato"].includes(type) && "Publicidad"}
                    {["HW-CAPEX", "HW-OPEX"].includes(type) && "Hardware"}
                    {type === "Gestión" && "Gestión"}
                    {type === "BTL" && "BTL"}
                  </td>
                  <td className={styles.colSumEjecutivo}>{ejecutivoNombre}</td>
                  <td className={styles.colSumCliente}>{(cliente || "").toUpperCase()}</td>
                  <td className={styles.colSumNumeroFactura}>
                    {facturanumero || (
                      <span style={{ color: facturafecha ? "#dc3545" : undefined, fontWeight: facturafecha ? 600 : undefined }}>
                        -
                      </span>
                    )}
                  </td>
                  <td className={styles.colSumFechaFactura}>
                    {facturafecha ? (
                      <span style={{ color: "black" }}>
                        {fechaLocal(facturafecha).toLocaleDateString("es-ES", fecha)}
                      </span>
                    ) : (
                      <span style={{ color: "red" }}>
                        {mes && ano ? `${mesEnLetras(mes)}/${ano.slice(-2)}` : "-"}
                      </span>
                    )}
                  </td>
                  <td className={`${styles.colSumImporte} text-end`}>
                    {`${displayMoneda} ${importeDisplay.toLocaleString(localString(pais), {
                      maximumFractionDigits: displayDecimales,
                      minimumFractionDigits: displayDecimales,
                    })}`}
                  </td>
                  <td
                    className={styles.colSumCobrada}
                    style={{
                      backgroundColor: estado.bg,
                      color: "white",
                      fontWeight: "500",
                    }}
                  >
                    {estado.text}
                  </td>
                </tr>
              );
            })
          )}
        </tbody>
      </table>
    </div>
  );

  const renderTableHardware = () => (
    <div className={styles.tableResponsive}>
      <table className={`table table-hover table-striped ${styles.table}`}>
        <thead className="text-center align-middle">
          <tr>
            <th className={styles.colHwId}>ID</th>
            <th className={styles.colHwEjecutivo}>EJECUTIVO</th>
            <th className={styles.colHwCliente}>CLIENTE</th>
            <th className={styles.colHwModalidad}>MODALIDAD</th>
            <th className={styles.colHwNumeroFactura}>Nº FACTURA</th>
            <th className={styles.colHwFechaFactura}>FECHA FACTURA</th>
            <th className={styles.colHwImporte}>IMPORTE</th>
            <th className={styles.colHwCobrada}>COBRADA</th>
            <th className={styles.colHwEditar}>EDIT</th>
          </tr>
        </thead>
        <tbody>
          {oportunidadesFiltradas.length === 0 ? (
            <tr>
              <td colSpan="9" className="text-center">
                No hay facturas de hardware según los filtros seleccionados
              </td>
            </tr>
          ) : (
            oportunidadesFiltradas.map((oportunidad) => {
              const {
                id,
                display_id,
                type,
                ejecutivoNombre,
                facturafecha,
                facturanumero,
                cliente,
                facturafechacobro,
                plazocobro,
                mes,
                ano,
              } = oportunidad;

              const estado = getEstadoCobro(facturafecha, facturafechacobro, plazocobro);
              const importeLocal = getConvertedImporte(oportunidad, getRateForOportunidad(oportunidad));
              const dolarRate = getDolarRateForDate(facturafecha);
              const importeDisplay = filtroMoneda === "USD" ? importeLocal / dolarRate : importeLocal;

              return (
                <tr key={id}>
                  <td className={`${styles.colHwId} bg-success text-white`}>{display_id || id}</td>
                  <td className={styles.colHwEjecutivo}>{ejecutivoNombre}</td>
                  <td className={styles.colHwCliente}>{(cliente || "").toUpperCase()}</td>
                  <td className={styles.colHwModalidad}>
                    {type === "HW-CAPEX" ? "CAPEX" : "OPEX"}
                  </td>
                  <td className={styles.colHwNumeroFactura}>
                    {facturanumero || (
                      <span style={{ color: facturafecha ? "#dc3545" : undefined, fontWeight: facturafecha ? 600 : undefined }}>
                        -
                      </span>
                    )}
                  </td>
                  <td className={styles.colHwFechaFactura}>
                    {facturafecha ? (
                      <span style={{ color: "black" }}>
                        {fechaLocal(facturafecha).toLocaleDateString("es-ES", fecha)}
                      </span>
                    ) : (
                      <span style={{ color: "red" }}>
                        {mes && ano ? `${mesEnLetras(mes)}/${ano.slice(-2)}` : "-"}
                      </span>
                    )}
                  </td>
                  <td className={`${styles.colHwImporte} text-end`}>
                    {`${displayMoneda} ${importeDisplay.toLocaleString(localString(pais), {
                      maximumFractionDigits: displayDecimales,
                      minimumFractionDigits: displayDecimales,
                    })}`}
                  </td>
                  <td
                    className={styles.colHwCobrada}
                    style={{
                      backgroundColor: estado.bg,
                      color: "white",
                      fontWeight: "500",
                    }}
                  >
                    {estado.text}
                  </td>
                  <td className={`${styles.colHwEditar} text-center align-middle`}>
                    {(() => {
                      const editable = type === "HW-CAPEX"
                        ? puedeEditar
                        : puedeEditar && esCuotaEditable(mes, ano);
                      return (
                        <FaEdit
                          onClick={editable ? () => handleOpenModal(oportunidad) : undefined}
                          style={{
                            cursor: editable ? "pointer" : "not-allowed",
                            fontSize: "1.2em",
                            opacity: editable ? 1 : 0.4,
                          }}
                        />
                      );
                    })()}
                  </td>
                </tr>
              );
            })
          )}
        </tbody>
      </table>
    </div>
  );

  const renderTableGestion = () => (
    <div className={styles.tableResponsive}>
      <table className={`table table-hover table-striped ${styles.table}`}>
        <thead className="text-center align-middle">
          <tr>
            <th className={styles.colGesId} rowSpan="2">ID</th>
            <th className={styles.colGesEjecutivo} rowSpan="2">EJECUTIVO</th>
            <th className={styles.colGesCliente} rowSpan="2">CLIENTE</th>
            <th colSpan="2" className={styles.colGesCuotaHeader}>CUOTA</th>
            <th className={styles.colGesNumeroFactura} rowSpan="2">Nº FACTURA</th>
            <th className={styles.colGesFechaFactura} rowSpan="2">FECHA FACTURA</th>
            <th className={styles.colGesImporte} rowSpan="2">IMPORTE</th>
            <th className={styles.colGesCobrada} rowSpan="2">COBRADA</th>
            <th className={styles.colGesEditar} rowSpan="2">EDIT</th>
          </tr>
          <tr>
            <th className={styles.colGesValorCuota}>VALOR</th>
            <th className={styles.colGesCuota}>PERIODO</th>
          </tr>
        </thead>
        <tbody>
          {oportunidadesFiltradas.length === 0 ? (
            <tr>
              <td colSpan="10" className="text-center">
                No hay facturas de gestión según los filtros seleccionados
              </td>
            </tr>
          ) : (
            oportunidadesFiltradas.map((oportunidad) => {
              const {
                id,
                display_id,
                ejecutivoNombre,
                facturafecha,
                facturanumero,
                cliente,
                facturafechacobro,
                plazocobro,
                mes,
                ano,
                label_extra,
                valor_cuota,
                moneda_cuota,
              } = oportunidad;

              const estado = getEstadoCobro(facturafecha, facturafechacobro, plazocobro);
              const importeLocal = getConvertedImporte(oportunidad, getRateForOportunidad(oportunidad));
              const dolarRate = getDolarRateForDate(facturafecha);
              const importeDisplay = filtroMoneda === "USD" ? importeLocal / dolarRate : importeLocal;

              const valorCuotaDisplay = valor_cuota
                ? `${valor_cuota.toLocaleString(localString(pais), {
                  maximumFractionDigits: moneda_cuota === "UF" ? 2 : 0,
                  minimumFractionDigits: moneda_cuota === "UF" ? 2 : 0,
                })} ${moneda_cuota || ""}`
                : "-";

              return (
                <tr key={id}>
                  <td className={`${styles.colGesId} bg-success text-white`}>{display_id || id}</td>
                  <td className={styles.colGesEjecutivo}>{ejecutivoNombre}</td>
                  <td className={styles.colGesCliente}>{(cliente || "").toUpperCase()}</td>
                  <td className={`${styles.colGesValorCuota} text-center`}>{valorCuotaDisplay}</td>
                  <td className={`${styles.colGesCuota} text-center`}>{label_extra || "-"}</td>
                  <td className={styles.colGesNumeroFactura}>
                    {facturanumero || (
                      <span style={{ color: facturafecha ? "#dc3545" : undefined, fontWeight: facturafecha ? 600 : undefined }}>
                        -
                      </span>
                    )}
                  </td>
                  <td className={styles.colGesFechaFactura}>
                    {facturafecha ? (
                      <span style={{ color: "black" }}>
                        {fechaLocal(facturafecha).toLocaleDateString("es-ES", fecha)}
                      </span>
                    ) : (
                      <span style={{ color: "red" }}>
                        {mes && ano ? `${mesEnLetras(mes)}/${ano.slice(-2)}` : "-"}
                      </span>
                    )}
                  </td>
                  <td className={`${styles.colGesImporte} text-end`}>
                    {`${displayMoneda} ${importeDisplay.toLocaleString(localString(pais), {
                      maximumFractionDigits: displayDecimales,
                      minimumFractionDigits: displayDecimales,
                    })}`}
                  </td>
                  <td
                    className={styles.colGesCobrada}
                    style={{
                      backgroundColor: estado.bg,
                      color: "white",
                      fontWeight: "500",
                    }}
                  >
                    {estado.text}
                  </td>
                  <td className={`${styles.colGesEditar} text-center align-middle`}>
                    <FaEdit
                      onClick={
                        puedeEditar && esCuotaEditable(mes, ano)
                          ? () => handleOpenModal(oportunidad)
                          : undefined
                      }
                      style={{
                        cursor: puedeEditar && esCuotaEditable(mes, ano) ? "pointer" : "not-allowed",
                        fontSize: "1.2em",
                        opacity: puedeEditar && esCuotaEditable(mes, ano) ? 1 : 0.4,
                      }}
                    />
                  </td>
                </tr>
              );
            })
          )}
        </tbody>
      </table>
    </div>
  );

  return (
    <div className={styles.containerFacturasDetalle}>
      <Header centerContent={renderFilters()} />

      {/* Checkboxes de tipo de negocio */}
      <div className={styles.tipoCheckboxes}>
        {[
          { value: "", label: "TODO", pctKey: null, color: null },
          { value: "publicidad", label: "PUBLICIDAD", pctKey: "publicidad", color: "#0d6efd" },
          { value: "hardware", label: "HARDWARE", pctKey: "hardware", color: "#198754" },
          { value: "Gestión", label: "GESTIÓN", pctKey: "gestion", color: "#6f42c1" },
          { value: "BTL", label: "BTL", pctKey: "btl", color: "#fd7e14" },
        ].map((opt) => {
          const pct = opt.pctKey ? porcentajesVertical[opt.pctKey] : null;
          return (
            <label key={opt.value} className={styles.tipoCheckboxLabel}>
              <input
                type="checkbox"
                checked={filtroTipo === opt.value}
                onChange={() => {
                  const newVal = filtroTipo === opt.value ? "" : opt.value;
                  setFiltroTipo(newVal);
                  if (newVal !== "hardware") setFiltroModalidad("");
                }}
                className={styles.tipoCheckboxInput}
              />
              <span className={styles.tipoLabelContent}>
                {opt.label}
                {pct != null && (
                  <span className={styles.tipoPctBadge} style={{ backgroundColor: opt.color }}>
                    {pct}%
                  </span>
                )}
              </span>
            </label>
          );
        })}
      </div>

      {/* Cards de totales */}
      <div className={styles.cardsSection}>
        <div className={styles.card}>
          <div className={styles.cardLabel}>BRUTO</div>
          <div className={styles.cardValue}>
            {`${displayMoneda} ${(totales.totalVenta || 0).toLocaleString(localString(pais), {
              maximumFractionDigits: displayDecimales,
              minimumFractionDigits: displayDecimales,
            })}`}
          </div>
        </div>
        <div className={`${styles.card} ${styles.cardGreen}`}>
          <div className={styles.cardLabel}>FACTURADO</div>
          <div className={styles.cardValue}>{`${(totales.porcentajeFacturado || 0).toFixed(0)}%`}</div>
        </div>
        <div className={`${styles.card} ${styles.cardRed}`}>
          <div className={styles.cardLabel}>PENDIENTE</div>
          <div className={styles.cardValue}>{`${(100 - (totales.porcentajeFacturado || 0)).toFixed(0)}%`}</div>
        </div>
        <div className={styles.card}>
          <div className={styles.cardLabel}>INTERMEDIACIÓN</div>
          <div className={styles.cardValue}>
            {!filtroTipo || ["publicidad", "BTL"].includes(filtroTipo)
              ? `${displayMoneda} ${(totales.totalComisionIntermediario || 0).toLocaleString(
                localString(pais),
                { maximumFractionDigits: displayDecimales, minimumFractionDigits: displayDecimales }
              )}`
              : "-"}
          </div>
        </div>
        <div className={styles.card}>
          <div className={styles.cardLabel}>NETO</div>
          <div className={styles.cardValue}>
            {!filtroTipo || ["publicidad", "BTL"].includes(filtroTipo)
              ? `${displayMoneda} ${(totales.totalNeto || 0).toLocaleString(
                localString(pais),
                { maximumFractionDigits: displayDecimales, minimumFractionDigits: displayDecimales }
              )}`
              : "-"}
          </div>
        </div>
        <div className={styles.card}>
          <div className={styles.cardLabel}>COBRADO</div>
          <div className={styles.cardValue}>
            {`${displayMoneda} ${(totales.totalCobrado || 0).toLocaleString(localString(pais), {
              maximumFractionDigits: displayDecimales,
              minimumFractionDigits: displayDecimales,
            })}`}
          </div>
        </div>
        <div className={styles.card}>
          <div className={styles.cardLabel}>PENDIENTE DE COBRO</div>
          <div className={styles.cardValue}>
            {`${displayMoneda} ${((totales.totalVenta || 0) - (totales.totalCobrado || 0)).toLocaleString(localString(pais), {
              maximumFractionDigits: displayDecimales,
              minimumFractionDigits: displayDecimales,
            })}`}
          </div>
        </div>
      </div>

      {/* Tabla condicional según tipo filtrado */}
      {(() => {
        if (!filtroTipo) return renderTableSummary();
        if (filtroTipo === "publicidad") return renderTablePublicidad();
        if (filtroTipo === "BTL") return renderTablePublicidad();
        if (filtroTipo === "hardware") return renderTableHardware();
        if (filtroTipo === "Gestión") return renderTableGestion();
        return renderTableSummary();
      })()}
      {/* Modal para editar factura */}
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Editar Factura</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {error && <div className="alert alert-danger">{error}</div>}
          {oportunidadEditada
            && (oportunidadEditada.type === "HW-OPEX" || oportunidadEditada.type === "Gestión")
            && (
              <div
                style={{
                  background: "#f8f9fa",
                  border: "1px solid #dee2e6",
                  borderRadius: "6px",
                  padding: "10px 14px",
                  marginBottom: "16px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div>
                  <span style={{ fontSize: "0.75rem", color: "#6c757d", display: "block" }}>Valor Cuota</span>
                  <span style={{ fontSize: "0.95rem", fontWeight: 600 }}>
                    {oportunidadEditada.valor_cuota != null
                      ? `${Number(oportunidadEditada.valor_cuota).toLocaleString("es-CL", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })} ${oportunidadEditada.moneda_cuota === "dolar" ? "US$" : "UF"}`
                      : "—"}
                  </span>
                </div>
                <div style={{ textAlign: "right" }}>
                  <span style={{ fontSize: "0.75rem", color: "#6c757d", display: "block" }}>Periodo</span>
                  <span style={{ fontSize: "0.95rem", fontWeight: 600 }}>
                    {oportunidadEditada.label_extra || "—"}
                  </span>
                </div>
              </div>
            )}
          <Form>
            <Form.Group className="mb-3" controlId="formNumeroFactura">
              <Form.Label>Número de Factura *</Form.Label>
              <Form.Control
                type="text"
                name="facturanumero"
                value={formData.facturanumero}
                onChange={handleInputChange}
                placeholder="Ingrese el número de factura"
                disabled={loading}
                required
                style={
                  formData.facturafecha && !formData.facturanumero
                    ? { borderColor: "#dc3545", boxShadow: "0 0 0 0.2rem rgba(220,53,69,.25)" }
                    : {}
                }
              />
              {formData.facturafecha && !formData.facturanumero && (
                <Form.Text style={{ color: "#dc3545", fontSize: "0.75rem" }}>
                  Falta número de factura
                </Form.Text>
              )}
            </Form.Group>

            <Form.Group className="mb-3" controlId="formFechaFactura">
              <Form.Label>Fecha de Factura *</Form.Label>
              <Form.Control
                type="date"
                name="facturafecha"
                value={formData.facturafecha}
                onChange={handleInputChange}
                disabled={loading}
                min="2023-01-01"
                max="2050-12-31"
                required
              />
            </Form.Group>

            {/* NUEVO CAMPO */}
            <Form.Group className="mb-3" controlId="formPlazoCobro">
              <Form.Label>Fecha de Cobro Proyectada *</Form.Label>
              <Form.Control
                type="date"
                name="plazocobro"
                value={formData.plazocobro}
                onChange={handleInputChange}
                disabled={loading}
                min={formData.facturafecha || undefined}
                required
              />
            </Form.Group>

            {/* RENOMBRADO */}
            <Form.Group className="mb-3" controlId="formFechaCobroReal">
              <Form.Label>Fecha de Cobro Real</Form.Label>
              <Form.Control
                type="date"
                name="facturafechacobro"
                value={formData.facturafechacobro}
                onChange={handleInputChange}
                disabled={loading}
                min={formData.facturafecha || undefined}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal} disabled={loading}>
      Cancelar
          </Button>
          <Button variant="primary" onClick={handleSaveChanges} disabled={loading}>
            {loading ? "Guardando..." : "Guardar Cambios"}
          </Button>
        </Modal.Footer>
      </Modal>
      {/* Modal asignar edificios para contratos AR */}
      <ModalAsignarEdificios
        show={showEdificiosModal}
        onHide={() => {
          setShowEdificiosModal(false);
          setEdificiosMesTarget(null);
        }}
        onSave={handleSaveEdificios}
        pais={pais}
        personasComprometidas={edificiosMesTarget?.personas_comprometidas || 0}
        edificiosIdsActuales={edificiosMesTarget?.edificios_ids || null}
        mesLabel={edificiosMesTarget?.label_extra || ""}
      />
    </div>
  );
};